import { Box, Grid, Toolbar, Link } from '@mui/material'
import { string } from 'prop-types'
import NextImageWrapper from '../../images/NextImageWrapper'

export default function PartnershipBarDesktop({
  testId = 'partnership-bar-desktop',
}) {
  return (
    <Toolbar
      disableGutters
      sx={{
        height: '44px !important',
        minHeight: '44px !important',
        position: 'relative',
        backgroundColor: 'rgb(0 17 34 / 1)',
        paddingLeft: { xs: 'calc(2vw + 27px)', xl: 'calc(10vw + 27px)' },
        paddingRight: { xs: '2vw', xl: '10vw' },
      }}
      data-testid={testId}
    >
      <Grid container alignItems='center'>
        <Grid mobileCutoff={10} container>
          <Box mr={1.75} tabIndex='0'>
            <Link
              href='/'
              sx={{
                cursor: 'pointer',
                position: 'static',
                padding: '12px',
                backgroundColor: 'white',
              }}
            >
              <NextImageWrapper
                testId={`${testId}-ascd-logo`}
                priority
                src={'/images/logo.svg'}
                alt='Homepage'
                width={61}
                height={20}
              />
            </Link>
            <Link
              href='https://iste.org/'
              sx={{
                cursor: 'pointer',
                position: 'static',
                padding: '12px',
              }}
            >
              <NextImageWrapper
                testId={`${testId}-iste-logo`}
                priority
                src={'/images/isteLogo.svg'}
                alt='ISTE'
                width={36}
                height={20}
              />
            </Link>
            <Link
              href='https://www.edsurge.com/'
              sx={{
                cursor: 'pointer',
                position: 'static',
                padding: '12px',
              }}
            >
              <NextImageWrapper
                testId={`${testId}-edsurge-logo`}
                priority
                src={'/images/edsurgeLogo.svg'}
                alt='EdSurge'
                width={60}
                height={20}
              />
            </Link>
          </Box>
        </Grid>
      </Grid>
    </Toolbar>
  )
}

PartnershipBarDesktop.propTypes = {
  testId: string,
}
